import React, { useRef, useState } from 'react';
import { groupBy, findIndex, filter, map } from 'lodash';
import { Dialog, DialogActions, DialogContent, Slide } from "@mui/material";
import { GradientColorHeader } from "@Local/Components/Dialog";
import { AutocompleteField, Button, FormControlLabel, Grid, Radio, RadioGroup } from '@curves/ui-base';

import { TagSection } from "@Local/Dashboard/Components";
import { filterTargetTypeMap } from "@Local/Dashboard/staticData";
import { v4 as uuid } from 'uuid';
const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="left" ref={ref} {...props} />;
});
const AdvancedChartFilterClubDialog = (props) => {
    const {
        open: openProps = false,
        onClose: onCloseProps,
        onConfirm: onConfirmProps,
        options: optionProps = {},
        selected: selectedProps = []
    } = props;
    const defaultRadioGroup = (
        findIndex(selectedProps, { targetType: filterTargetTypeMap.singleClub }) >= 0 ||
        findIndex(selectedProps, { targetType: filterTargetTypeMap.clubTag }) === -1
    ) ? 'CLUB' : 'TAGS';
    const defaultClubSelectValue = map(filter(selectedProps, { targetType: filterTargetTypeMap.singleClub }), 'targetID');
    const defaultClubSection = groupBy(selectedProps, 'tagType');
    const [radioGroupValue, setRadioGroupValue] = useState(defaultRadioGroup);
    const [dialogKey, setDialogKey] = useState(uuid());
    const [clearKey, setClearKey] = useState(null);
    const clubSelectorRef = useRef(null);
    const sectionRef = useRef({});
    const { clubTagGroupOptions = [], clubOption = [] } = optionProps || {};
    const handleChangeClub = (e) => {
        setRadioGroupValue(e.target.value);
    };
    const handleClickReset = () => {
        setRadioGroupValue(defaultRadioGroup);
        setClearKey('RESET');
        setDialogKey(uuid());
    };
    const handleClickClearAll = () => {
        setRadioGroupValue('CLUB');
        setClearKey('ALL');
        setDialogKey(uuid());
    };
    const handleConfirm = () => {
        let result = [];
        if (radioGroupValue === 'CLUB') {
            const selected = clubSelectorRef.current.getResult();
            if (selected) {
                selected.forEach(item => result.push({
                    targetType: filterTargetTypeMap.singleClub,
                    tagType: 0,
                    targetID: item.value,
                    targetName: item.text
                }));
            }
        } else if (radioGroupValue === 'TAGS') {
            clubTagGroupOptions.forEach((option) => {
                result = result.concat(sectionRef.current[option.tagType].getResult());
            });
        }
        onConfirmProps && onConfirmProps(result);
        onCloseProps && onCloseProps();
    };
    return (
        <Dialog open={openProps} TransitionComponent={Transition} fullScreen>
            <GradientColorHeader onClose={onCloseProps}>選擇店舖或店舖標籤</GradientColorHeader>
            <DialogContent>
                <Grid container spacing={5}>
                    <Grid item xs={12}>
                        <RadioGroup
                            key={`dialog_${dialogKey}`}
                            defaultValue={radioGroupValue} onChange={handleChangeClub}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}><FormControlLabel value={'CLUB'} label={'單一店舖'} control={<Radio />} /></Grid>
                                <Grid item xs={6}><FormControlLabel value={'TAGS'} label={'店舖標籤'} control={<Radio />} /></Grid>
                            </Grid>
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={6}>
                        <AutocompleteField
                            key={`clubSelector_${dialogKey}`}
                            inputProps={{ placeholder: '請輸入店名/店碼' }}
                            options={clubOption}
                            optionKeys={['text']}
                            direction="row"
                            disabled={radioGroupValue !== 'CLUB'}
                            primaryKey={'value'}
                            defaultValue={clearKey === 'ALL' ? null : defaultClubSelectValue}
                            fullWidth
                            ref={clubSelectorRef}
                            multiple
                        />
                    </Grid>
                    <Grid item xs={6}>
                        {clubTagGroupOptions && clubTagGroupOptions.map((option) => {
                            const { tagType, tagTypeText, tagOptions } = option;
                            const defaultSelected = clearKey === 'ALL' ? [] : map(defaultClubSection[tagType] || [], 'targetID');
                            return <TagSection key={`tag-section-${tagType}_${dialogKey}`}
                                               tagType={tagType}
                                               targetType={filterTargetTypeMap.clubTag}
                                               label={tagTypeText}
                                               tagOptions={tagOptions}
                                               defaultSelected={defaultSelected}
                                               disabled={radioGroupValue !== 'TAGS'}
                                               ref={(el) => (sectionRef.current[tagType] = el)}
                            />;
                        })}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClickReset} color="primary">
                    重置選項
                </Button>
                <Button variant="outlined" onClick={handleClickClearAll} color="primary">
                    清除全部
                </Button>
                <Button variant="contained" color="primary" onClick={handleConfirm}>
                    確認
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default AdvancedChartFilterClubDialog;